function a(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var s = a;
export {
  s as default
};
//# sourceMappingURL=_hashDelete.js.map
